import React from 'react';
import IOCloseCircled from 'react-icons/lib/io/close-circled';
import {FormControl} from 'react-bootstrap';

export function renderPayoutRules({payoutRules, deletePayoutRule, onPriceRangeAmountChange, onPayoutPercentageChange}) {
  return payoutRules.map((payoutRule, index) => {
    const {conditions = []} = payoutRule;
    let operatorToDisplay = false;

    if (index == 0) {
      operatorToDisplay = '<';
    } else if (index == payoutRules.length - 1) {
      operatorToDisplay = '>=';
    }

    return <div key={index} className="flex-box  space-between top10 bot30">
      <div style={{'width': '40%'}}>
        <div className="flex-box  space-between" style={{height: '30px'}}>

          <IOCloseCircled className="cursor-pointer"
                          onClick={()=>deletePayoutRule(index)}
                          style={{
                            width: 23,
                            visibility: operatorToDisplay ? 'hidden' : 'visible',
                            selfAlign: 'left',
                            height: '30px',
                            color: 'gray'
                          }}>

          </IOCloseCircled>

          {operatorToDisplay && <span className="text-center"
                                      style={{position: 'relative', top: 4, 'width': 60}}>{operatorToDisplay}</span>}

          {conditions.map((condition, conditionIndex) => {
            return <FormControl key={conditionIndex} style={{'width': 60}} type="text" className="text-center"
                                ref={`priceAmountTextInput_${index}`}
                                onChange={({target: {value}}) => onPriceRangeAmountChange(value, index, payoutRule, conditionIndex)}
                                value={conditions[conditionIndex].number}/>;
          })}

        </div>
      </div>
      <div className="flex-box justify-content-center" style={{'width': '40%'}}>
        <FormControl style={{'width': 60}} type="text" className="text-center"
                     onChange={({target: {value}}) =>onPayoutPercentageChange(value, index, payoutRule)}
                     value={payoutRule.value}/>
      </div>
    </div>;
  });
}


